import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Text, Box } from 'rebass/styled-components';
import { DropdownItemsType } from 'util/types';

const ItemContainer = styled(Box)`
  width: 100%;
  box-sizing: border-box;
`;

// UI refresh: plain white menu items with a soft hover, like a native menu.
const Item = styled.div<{ disabled?: boolean }>`
  min-height: 34px;
  border-radius: 8px;
  background-color: transparent;
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
  :hover {
    background-color: ${(p) => (p.disabled ? 'transparent' : '#F1F2F4')};
  }
  padding: 0 10px;
  display: flex;
  align-items: center;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
`;

const ItemText = styled(Text)`
  color: #16181d;
  font-size: 14px;
  user-select: none;
  white-space: nowrap;
`;

type Props = {
  menuItems: DropdownItemsType[];
  onSelect(item: DropdownItemsType): void;
  close(): void;
  containerRef: HTMLDivElement;
};

export const DropItems: React.FC<Props> = ({ menuItems, onSelect, close, containerRef }) => {
  const ref = useRef(null);

  const itemClick = (item: DropdownItemsType) => {
    if (!item.disabled) {
      onSelect(item);
    }
  };

  useEffect(() => {
    const handleClick = (event: any) => {
      if ((ref.current! as HTMLDivElement).contains(event.target) || containerRef.contains(event.target)) {
      } else {
        close();
      }
    };
    document.addEventListener('mousedown', handleClick, false);
    return () => {
      document.removeEventListener('mousedown', handleClick, false);
    };
  }, []);

  return (
    <ItemContainer ref={ref}>
      {menuItems.map((item, index) => (
        <Item key={`${item.label}${index}`} disabled={item.disabled} onClick={() => itemClick(item)}>
          <ItemText>{item.label}</ItemText>
        </Item>
      ))}
    </ItemContainer>
  );
};
